import React from 'react';

import { Box, Grid, makeStyles, Theme } from '@material-ui/core';

import { PagedList } from '../../../common/components/PagedList';
import { selectHomeIsRequestingList } from '../homeSlice';
import { UncontrolledTextField } from '../../../common/components/TextField';
import { useAppSelector } from '../../../app/hooks';
import ListItem from './ListItem';
import ListShipData from '../../../common/data-types/ship-list-data';
import Ship from '../../../common/data-types/ship-data';

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    marginBottom: 15,
  },
}));

const HEADERS: string[] = [
  'Navio',
  'Viagem',
  'Previsão Chegada',
  'Chegada',
  'Previsão Atracação',
  'Atracação',
  'Início Operação',
  'Previsão Saida',
  'Término operação',
  'Saída',
  'Abertura de Gate',
  'Deadline',
  'Joint',
  'Berço',
];

interface ListProps {
  currentPage: number;
  rowsPerPage: number;
  shipList: ListShipData;
  onChangeRowsPerPage: (rows: number) => void;
  onChangeShipName: (name: string) => void;
  onSetCurrentPage: (page: number) => void;
}

const List = ({
  currentPage,
  rowsPerPage,
  shipList,
  onChangeRowsPerPage,
  onChangeShipName,
  onSetCurrentPage,
}: ListProps) => {
  const classes = useStyles();

  const isLoading = useAppSelector(selectHomeIsRequestingList);

  return (
    <Box>
      <Grid container>
        <Grid item xs={3}>
          <UncontrolledTextField
            className={classes.input}
            label="Navio"
            name="shipName"
            placeholder="Buscar navio movimento"
            onChange={(e) => onChangeShipName(e.target.value)}
          />
        </Grid>
      </Grid>
      <PagedList
        count={shipList.total}
        currentPage={currentPage}
        headers={HEADERS}
        isLoading={isLoading}
        rowsPerPage={rowsPerPage}
        onPageChange={(page: number) => onSetCurrentPage(page)}
        onChangeRowsPerPage={onChangeRowsPerPage}
      >
        {shipList.list.map((data: Ship) => (
          <ListItem key={data.id} data={data} />
        ))}
      </PagedList>
    </Box>
  );
};

export default List;
